<template>
    <div class="page">
        <slot/>
        <Footer/>
    </div>
</template>
<script>
import { Footer } from '.';

export default {
    name: 'Page',
    components: { Footer },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.page {
    @include flex-vertical();
    flex-grow: 1;
    position: relative;
}
</style>
